import { useEffect } from 'react';
import styled from 'styled-components';
import { LoadingIcon } from '@prosolve/common-components-ui'
import useFetch from '../hooks/useFetch';

const LoadingIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5px;
`;

export default () => {
  const url = new URL(window.location);
  const { searchParams } = url;
  const code = searchParams.get("code");
  const token = searchParams.get("token");
  const error = searchParams.get("error");

  const fetch = useFetch();

  useEffect(() => {
    if (error) {
      window.location.href = '/?ssoError=true';
    } else {
      const fn = async () => {
        try {
          const response = await fetch(
            `auth/ssoVerify`,
            {
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
              },
              // credentials: "include",
              body: JSON.stringify({ code, token })
            }
          )
          const jsonData = await response.json() || {};
          if (jsonData.status) {
            window.location.href = '/';
          } else {
            window.location.href = '/?ssoError=true';
          }
        } catch (e) {
          console.log(e)
          window.location.href = '/?ssoError=true';
        }
      }
      fn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, token, error])

  return (
    <LoadingIconWrapper>
      <LoadingIcon />
    </LoadingIconWrapper>
  )
}
